exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflowHidden>p{margin-left:10px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;border:1px solid #ccc}.edit-scale{width:100%}.edit-scale .l-radio-group,.edit-scale .vux-rater{display:-ms-flexbox;display:flex;width:100%;-ms-flex-pack:justify;justify-content:space-between}.edit-scale .l-radio-group.flex-row .l-radio:not(:last-child){margin-right:4px}.edit-scale .l-radio .l-radio-label{margin-left:2px}", ""]);

// exports
